/**
 * @generated SignedSource<<75893025eb5a52ea00f0fff3088f9bea>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AppRoutesLayout_accounts$data = {
  readonly UrlConfig: {
    readonly jun0: string | null | undefined;
  } | null | undefined;
  readonly accounts: {
    readonly pageInfo: {
      readonly total: number | null | undefined;
    };
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
  };
  readonly whoami: {
    readonly __typename: "CurrentUser";
    readonly config: {
      readonly isOnboardingSkipped: boolean | null | undefined;
    } | null | undefined;
  };
  readonly " $fragmentType": "AppRoutesLayout_accounts";
};
export type AppRoutesLayout_accounts$key = {
  readonly " $data"?: AppRoutesLayout_accounts$data;
  readonly " $fragmentSpreads": FragmentRefs<"AppRoutesLayout_accounts">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AppRoutesLayout_accounts",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AccountConnection",
      "kind": "LinkedField",
      "name": "accounts",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "problems",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "message",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "total",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CurrentUser",
      "kind": "LinkedField",
      "name": "whoami",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Config",
              "kind": "LinkedField",
              "name": "config",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isOnboardingSkipped",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UrlConfig",
          "kind": "LinkedField",
          "name": "UrlConfig",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "jun0",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "4cd4449f7e580017b7344ecd4b27e5ff";

export default node;
